<template>
  <div id="privateChatMsg">
    <div class="cooperation_detail_lvDi">
      <div class="cooperation_detail_right">
        <el-container class="content">
          <!-- 消息-->
          <div class="el-main" id="input" ref="input">
            <el-row v-for="(m,index) in msg" :key="index" class="msgBox">
              <el-col>
                <el-row class="time">
                  {{ m.admin?m.admin:username }} {{ m.createTime }}
                </el-row>
                <el-row>
                  <el-col v-if="m.tag==0" :span="24">
                    <span>{{ m.comment }}</span>
                  </el-col>
                  <el-col v-else-if="m.tag==1" :span="24" style="height: 140px">
                    <img @click="showimg(m.comment +userSuffix)" style="height: 100%;max-width: 300px"
                         fit="contain" :src="m.comment +userSuffix">
                  </el-col>
                  <el-col v-else-if="m.tag==2" :span="24" class="fileBoxOut">
                    <a :href="m.comment +userSuffix" target="_blank" class="fileBox">
                      <i class="el-icon-document"></i>
                      {{ m.comment+userSuffix.split("/").pop().split("_").pop() }}
                    </a>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-footer>
            <!--输入框-->
            <el-row :gutter="20" class="footer">
              <el-col :span="20">
                <el-input v-model="input" id="realinput" @focus="pageFresh"></el-input>
              </el-col>
              <el-col :span="4">
                <el-button v-if="edited" type="primary" @click="addinput">发送</el-button>
                <div v-else style="width: 100%;display: inline-flex;">
                  <el-upload :action="action" :before-upload="beforeAddimage" :data="uploadData"
                             :on-success="addimage" :show-file-list="false" accept=".jpg,.jpeg,.png"
                             class="icon">
                    <el-button circle icon="el-icon-picture"></el-button>
                  </el-upload>
                  <el-upload :action="action" :with-credentials="true" :data="uploadData"
                             :on-success="addfile" :show-file-list="false" class="icon">
                    <el-button circle icon="el-icon-folder-opened"></el-button>
                  </el-upload>
                </div>

              </el-col>
            </el-row>
          </el-footer>
        </el-container>
      </div>
      <div class="clear"></div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import API from "../../../../config/api";
export default {
  data() {
    return {
      msg: [],  //从后端返回的聊天记录消息
      input: "",
      inputbox: undefined,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      havemore: true,
      pageidx: 0,
      pagelength: 10,
      fartobottom: 0,
      userId: 0,
      username: '',
      action: '',
      watchwheel: true,

      charSearch: '',
      uploadData: {
        flag: 5,
        token: window.localStorage.getItem('token'),
        userid: window.localStorage.getItem('userid'),
      },
      // userSuffix:'',
    }
  },
  async mounted() {
    this.addNextPage(1, this.pagelength, this.havemore); //首次加载消息,因为云控组态的后端是pageNum从1开始和pageSize每页的条数，所以这里和与云报告不同
    this.action = 'https://www.yunkongzutai.cn/configcloud/file/fileUpload';
    this.inputbox = this.$refs.input; //this.$refs.input是对话框的上部分id=input
    this.inputbox.addEventListener("wheel", this.scrollEvent);
    let self = this;
    // this.userSuffix = "?userid="+window.localStorage.getItem('userid')+"&token="+window.localStorage.getItem('token');
    this.interval = setInterval(function() {
      //比较每次获得的最新的一条消息和当前消息列表里最后一条时间是否一样，不一样则重置消息列表

      let header1 = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data1 = {
        chatSearch: self.charSearch,
        pageNum: 1,//从哪一条开始查
        pageSize: 1,
      }
      self.$axiosRequest({
        url: API.getDiscussByUserId,
        method: 'GET',
        data: data1,
        header: header1,
        success: res1 => {
          let msgLen = self.msg.length;
          let lastMsg = self.msg[msgLen - 1];
          let lastMessages = res1.data.discuss;
          if (lastMessages[0].createTime !== lastMsg.createTime || lastMessages[0]
              .comment !== lastMsg.comment) {
            let header = {
              "Content-Type": "application/x-www-form-urlencoded"
            }

            let data = {
              chatSearch: self.charSearch,
              pageNum: 1,//从哪一条开始查
              pageSize: self.pagelength,
            }
            console.log(data)
            self.$axiosRequest({
              url: API.getDiscussByUserId,
              method: 'GET',
              data: data,
              header: header,
              success: res => {
                self.msg = res.data.discuss.reverse();
                const msgLen = self.msg.length;
                if (msgLen > self.pagelength) self.havemore = true;
                self.pageFresh()
              }
            });

          }
        }
      });
    }, 10000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  computed: {
    edited: function() {
      return !!this.input;
    },
  },
  watch: {
    pageidx: function(val) {
      this.addNextPage(val , this.pagelength, this.havemore);  //此处的val就是pageidx的值，就是页码，云报告此处是pageidx*val就是条数
    },
  },
  methods: {
    scrollEvent: function(event) {
      let self = this;
      if (self.watchwheel && self.havemore) {
        self.watchwheel = false;
        self.fartobottom = self.inputbox.scrollHeight - self.inputbox.clientHeight;
        if (event.deltaY < 0 && self.inputbox.scrollTop === 0) { //处于顶端仍向上滚动
          self.pageidx++;
          console.log(self.pageidx);
        }
        setTimeout(function() {
          self.watchwheel = true;
        }, 500);
      }
    },
    pageFresh: function() { //移动到最后一条消息
      this.inputbox.scrollTop = this.inputbox.scrollHeight - this.inputbox.clientHeight;
    },
    addNextPage: function(from, length, havemore) {
      let self = this;
      if (havemore) {
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {
          chatSearch: self.charSearch,
          pageNum: from,
          pageSize: length,
        }
        console.log(data)
        self.$axiosRequest({
          url: API.getDiscussByUserId,
          method: 'GET',
          data: data,
          header: header,
          success: res => {
            if (from == 0) {
              self.userId = res.data.userId;
              self.username = res.data.username;
            }
            var msgList = res.data.discuss.reverse();  //组态云后台聊天记录的返回是从最新到以前，所以要反过来然后再展示
            var msgLen = msgList.length;
            if (msgLen < length) self.havemore = false;
            self.msg.unshift(...msgList);  //头部插入元素
            self.inputbox.scrollTop = self.inputbox.scrollHeight - self.fartobottom - self
                .inputbox
                .clientHeight;
          }
        });
      }
    },
    postmsg: function(msg) {
      let self = this;
      msg.status = 0;
      msg.createTime = (new Date).toJSON().split('T')[0];
      this.msg.push(msg);
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        comment: msg.comment,
        tag: msg.tag,
      }
      this.$axiosRequest({
        url: API.AddPrivateComment,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            self.pageFresh
          } else if (res.data == -2) {
            self.$message({type: 'warning', message: '参数错误'});
            return;
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '程序错误'});
            return;
          }

        }
      });

    },
    addinput: function() {
      var last = {};
      last.comment = this.input;
      last.tag = 0;
      this.postmsg(last);
      this.input = "";
    },
    beforeAddimage(file) {
      const legal = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!legal) {
        this.$confirm('当前文件格式错误', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '',
          customClass: 'ownerConfirm',
          confirmButtonClass: 'ownerConfirmButtonClass',
          cancelButtonClass: 'ownerCancelButtonClass',
          type: 'error'
        }).then(() => {}).catch(() => {})
      }
      return legal;
    },
    addimage(response) {
      console.log(response)
      if (response !== "-1") {
        var last = {};
        last.tag = 1;
        last.comment = "https://www.yunkongzutai.cn/configcloud" + response; // 拼接域名
        this.postmsg(last);
      }
    },
    showimg: function(url) {  //点击聊天页面中的图片用对话框展示
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    addfile(response) {
      if (response !== "-1") {
        var last = {};
        last.tag = 2;
        last.comment = "https://www.yunkongzutai.cn/configcloud" + response // 拼接域名
        this.postmsg(last);
      }
    },

  },
}
</script>

<style lang="less">
#privateChatMsg {
  #input {
    height: 450px;
  }
  .el-input__inner{
    margin: 10px 0px;
  }
  .el-col-4{
    margin: 10px 0px;
    padding-left:0px!important;
  }
  .cooperation_detail_lvDi .cooperation_detail_left {
    float: left;
    width: 250px;
  }

  .cooperation_detail_right .detail {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .cooperation_detail_right .el-form-item {
    margin-bottom: 0;
    height: 40px;
    border-bottom: 1px solid rgb(220, 223, 224);
  }

  .cooperation_detail_right .el-upload__tip {
    display: inline-block;
    margin-top: 0;
  }

  .cooperation_detail_right .el-upload__tip .el-icon-warning {
    margin: 0 5px;
    color: red;
  }

  .clear {
    clear: both;
  }

  .ownerConfirm {
    width: 350px;
    border: #085394;
  }

  .ownerConfirm .el-message-box__header {
    background: #085394;

  }

  .ownerConfirm .el-message-box__title,
  .ownerConfirm .el-message-box__title span {
    color: #ffffff;
    font-size: 17px;
    font-weight: bold;
  }

  .ownerConfirm .el-message-box__headerbtn .el-message-box__close {
    color: #ffffff;
  }

  .ownerConfirmButtonClass,
  .ownerConfirmButtonClass:focus {
    background: #085394;
  }

  .ownerConfirmButtonClass:hover {
    background: #085394;
  }

  .icon {
    margin-right: 15px;
  }

  .title {
    text-align: center;
  }

  .fileBoxOut {
    margin: 5px 0;
  }

  .fileBox {
    border: 1px solid #eeeeee;
    border-radius: 5px;
    padding: 2px;
    display: inline;
  }

  .time {
    color: #909399;
    font-size: 12px;
  }

  .msgBox {
    margin: 10px 0;
  }
  .el-footer{
    //background-color: #FFFFFF;
    background-image:linear-gradient(-90deg, #81c9fe, #8bf);;
  }
}
</style>
